'use client';

import { useContext } from 'react';
import { SiteConfig } from './SiteConfig';

export function useSiteConfig() {
  const ctx = useContext(SiteConfig);
  if (!ctx) {
    throw new Error('useSiteMeta / useDictionary måste användas inom <SiteConfigProvider>.');
  }
  return ctx;
}

export function useSiteMeta() {
  return useSiteConfig().siteMeta;
}
